import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

import { MediaService } from "@/services/media-service";
import type { UploadMediaRequestDto, UploadMediaResponseDto } from "@/types";

type UsePostUploadMediaMutationParams = {
  options?: UseMutationOptions<
    UploadMediaResponseDto,
    unknown,
    UploadMediaRequestDto
  >;
};

export const usePostUploadMediaMutation = ({
  options
}: UsePostUploadMediaMutationParams = {}) => {
  return useMutation({
    mutationFn: async (payload) => {
      return await MediaService.uploadMedia({ payload });
    },
    ...options
  });
};
